import TableCommonHook from '@op/components/TableCommonHook';
import {
  dealwithValueFuncMap,
  indicatorsMap,
} from '@op/pages/Summary/constants';
import { IndicatorsType } from '@op/pages/Summary/context';
import { getPercentageValue } from '@op/utils';
import { formatDateFunc } from '@op/utils/time';
import { reviewsFormat } from '@op/utils/value';
import React, { useMemo } from 'react';
import { Bubble } from 'tea-component';
import { useIntl } from 'umi';

export default function DataTable({
  indicators,
  tableInfo,
  transTopic,
  dateType,
  height = 250
}: {
  indicators: IndicatorsType;
  tableInfo: any;
  transTopic: (name: string) => string;
  dateType: any;
  height?: number;
}) {
  const { formatMessage } = useIntl();
  const dealwithValueFunc = dealwithValueFuncMap[indicators];
  const [columns, records, minWidth]: [any, any, number] = useMemo(() => {
    const isRatio = ['mentions_ratio', 'negative_mentions', 'engagement_ratio'].includes(
      indicators,
    );
    let headerText = indicatorsMap[indicators];
    if (indicators === 'mentions_ratio') {
      headerText = 'Mentions';
    } else if (indicators === 'negative_mentions') {
      headerText = 'Negative Mentions';
    } else if (indicators === 'engagement_ratio') {
      headerText = 'Engagement';
    }

    const { header, data } = tableInfo;

    const tableColumns: Array<any> = [
      {
        key: 'time',
        header: formatMessage({ id: 'Time' }),
        fixed: 'left',
        render: (cvm: any) => formatDateFunc(dateType)(cvm.time),
      },
      {
        key: 'total',
        align: 'right',
        header: formatMessage({ id: headerText }),
        render: ({ total }: any) =>
          isRatio ? reviewsFormat(total) : dealwithValueFunc(total),
      },
    ];

    header.forEach((title: string) => {
      if (title === 'Others') return;
      const realTitle = transTopic(title);
      tableColumns.push({
        key: title,
        align: 'right',
        header: (
          <Bubble dark content={realTitle}>
            <div className="tea-text-overflow">{realTitle}</div>
          </Bubble>
        ),
        render: (cvm: any) => (
          <TableItem
            valueIsPrecess={isRatio}
            dealwithFunc={dealwithValueFunc}
            value={cvm[title]}
            total={indicators === 'sentiment' ? 5 : cvm.total}
          ></TableItem>
        ),
      });
    });

    const minWidth = header.length * 150;
    return [tableColumns, data, minWidth > 700 ? minWidth : 700];
  }, [tableInfo, transTopic, formatMessage]);

  return (
    <TableCommonHook
      className="topic-trends-table"
      bordered="all"
      recordKey={'time'}
      columns={columns}
      records={records}
      maxHeight={height}
      hasPageable={false}
      minWidth={minWidth}
    ></TableCommonHook>
  );
}

function TableItem({
  value,
  total,
  dealwithFunc,
  valueIsPrecess,
}: {
  dealwithFunc: (value: number) => string | number;
  value: number;
  total: number;
  valueIsPrecess: boolean;
}) {
  const chartPercentage = useMemo(() => {
    return (
      (valueIsPrecess ? value : getPercentageValue(value || 0, total)) * 100
    );
  }, [value, total]);

  return (
    <div className="table-cell-info">
      {/* 进度条，使用定位处理该内容 */}
      {
        <div
          className="percentage-info"
          style={{
            width: (chartPercentage > 100 ? 100 : chartPercentage) + '%',
          }}
        ></div>
      }
      <div className="value-box">
        <span className="value-info">{dealwithFunc(value)}</span>
      </div>
    </div>
  );
}
